<template>
  <div>
    <GroupTable />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import GroupTable from './components/GroupTable.vue';

export default {
  name: 'Groups',

  components: {
    GroupTable,
  },

  mounted() {
    this.fetchBatches({ page: 1, search: '' });
  },

  methods: {
    ...mapActions(['fetchBatches']),
  },
};
</script>
